import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const JustWinPM2Layout = () => {
  const { onSubmit, resource } = useMetaLayoutContext();

  const readonly = !resource.meta().action('PUT') && !resource.meta().action('POST');

  return (
    <FDStack direction={'column'}>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'subtitle'} />
          <MetaLayoutRemainingFields noAccordion />
        </FDStack>
      </FDDialogContent>
      {!readonly ? (
        <FDDialogActions>
          <FDStack spacing={2} width={'100%'} alignItems={'flex-start'}>
            <FDPrimaryActionButton label={'Save & close'} onClick={onSubmit} />
          </FDStack>
        </FDDialogActions>
      ) : null}
    </FDStack>
  );
};

JustWinPM2Layout.defaultProps = {};
JustWinPM2Layout.propTypes = {};

export { JustWinPM2Layout };
